<template>
    <el-form :model="formInfo" label-width="88px" style="margin-bottom: 0px;padding-top: 0px" ref="formInfo">
        <el-form-item :label="$t(timeLable)">
            <el-radio v-model="formInfo.iTimeMode" @change="changeTimeMode" label="0">{{ $t('pgCommon.ALL_TIME') }}</el-radio>
            <el-radio v-model="formInfo.iTimeMode" @change="changeTimeMode" label="1">{{ $t('pgCommon.DATE_MODE') }}</el-radio>
            <el-radio v-model="formInfo.iTimeMode" @change="changeTimeMode" label="2">{{ $t('pgCommon.WEEK_MODE') }}</el-radio>
        </el-form-item>
        <div v-if="visibleDate">
            <el-row v-for="(item, index) in rowsDate" :key="index">
                <el-col style="width:438px">
                    <el-form-item>
                        <td-date-time v-model="item.dateTime" type="datetimerange" :separator="$t('common.UNTIL')" :clearable="false"></td-date-time>
                    </el-form-item>
                </el-col>
                <el-col v-if="index === 0" style="width:30px;">
                    <el-form-item label-width="10px">
                        <td-button type="text" size="small" @click="addDate({}, index)"><img :src="addImg"/></td-button>
                    </el-form-item>
                </el-col>
                <el-col v-if="index !== 0" style="width:60px">
                    <el-form-item label-width="10px">
                        <td-button type="text" size="small" @click="addDate({}, index)"><img :src="addImg"/></td-button>
                        <td-button type="text" size="small" @click="deleteDate(index)"><img :src="delImg"/></td-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </div>
        <div v-if="visibleWeek">
            <el-row v-for="(item, index) in rowsWeek" :key="index">
                <el-col style="width:170px">
                    <el-form-item>
                        <td-select
                            v-model="item.startWeek"
                            @change="changeWeek(item, 'startWeek')"
                            :placeholder="$t('pgCommon.PLEASE_SELECT')"
                            width="90"
                            :options="weekList"
                            :clearable="false"
                            keys="value"
                            text="text"
                        ></td-select>
                    </el-form-item>
                </el-col>
                <el-col style="width:130px">
                    <el-form-item label-width="10px">
                        <td-date-time
                            v-model="item.startTime"
                            @change="changeTime(item, 'startTime')"
                            dateStyle="width:120px !important"
                            type="time"
                            :placeholder="$t('common.START_TIME')"
                            :clearable="false"
                        ></td-date-time>
                    </el-form-item>
                </el-col>
                <el-col style="width:25px">
                    <el-form-item label-width="10px">{{ $t('common.UNTIL') }}</el-form-item>
                </el-col>
                <el-col style="width:92px">
                    <el-form-item label-width="10px">
                        <td-select
                            v-model="item.endWeek"
                            @change="changeWeek(item, 'endWeek')"
                            :placeholder="$t('pgCommon.PLEASE_SELECT')"
                            width="90"
                            :options="weekList"
                            :clearable="false"
                            keys="value"
                            text="text"
                        ></td-select>
                    </el-form-item>
                </el-col>
                <el-col style="width:130px">
                    <el-form-item label-width="10px">
                        <td-date-time
                            v-model="item.endTime"
                            @change="changeTime(item, 'endTime')"
                            dateStyle="width:120px !important"
                            type="time"
                            :placeholder="$t('common.END_TIME')"
                            :clearable="false"
                        ></td-date-time>
                    </el-form-item>
                </el-col>
                <el-col v-if="index === 0" style="width:30px">
                    <el-form-item label-width="10px">
                        <td-button type="text" size="small" @click="addWeek('', '', '', '', index)"><img :src="addImg"/></td-button>
                    </el-form-item>
                </el-col>
                <el-col v-if="index !== 0" style="width:60px">
                    <el-form-item label-width="10px">
                        <td-button type="text" size="small" @click="addWeek('', '', '', '', index)"><img :src="addImg"/></td-button>
                        <td-button type="text" size="small" @click="deleteWeek(index)"><img :src="delImg"/></td-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </div>
    </el-form>
</template>
<script>
export default {
    props: ['timeLable'],
    // 定义变量
    data() {
        return {
            formInfo: {
                iTimeMode: window.pangu.common.timeMode.ALL_TIME
            },
            visibleDate: false,
            visibleWeek: false,
            rowsDate: [
                {
                    dateTime: []
                }
            ],
            rowsWeek: [
                {
                    startWeek: '',
                    startTime: '',
                    endWeek: '',
                    endTime: ''
                }
            ],
            weekList: [
                {
                    value: window.pangu.common.week.MONDAY,
                    text: this.$t('pgCommon.MONDAY')
                },
                {
                    value: window.pangu.common.week.TUESDAY,
                    text: this.$t('pgCommon.TUESDAY')
                },
                {
                    value: window.pangu.common.week.WEDNESDAY,
                    text: this.$t('pgCommon.WEDNESDAY')
                },
                {
                    value: window.pangu.common.week.THURSDAY,
                    text: this.$t('pgCommon.THURSDAY')
                },
                {
                    value: window.pangu.common.week.FRIDAY,
                    text: this.$t('pgCommon.FRIDAY')
                },
                {
                    value: window.pangu.common.week.SATURDAY,
                    text: this.$t('pgCommon.SATURDAY')
                },
                {
                    value: window.pangu.common.week.SUNDAY,
                    text: this.$t('pgCommon.SUNDAY')
                }
            ]
        };
    },
    computed: {
        addImg: function() {
            return 'pangu/' + window.vue.$store.state.skin + '/add.png';
        },
        delImg: function() {
            return 'pangu/' + window.vue.$store.state.skin + '/del.png';
        }
    },
    // 定义并实现方法体
    methods: {
        //报警时间方式改变执行的方法
        changeTimeMode(value) {
            this.visibleDate = false;
            this.visibleWeek = false;
            if (value === window.pangu.common.timeMode.DATE_MODE) {
                this.visibleDate = true;
            } else if (value === window.pangu.common.timeMode.WEEK_MODE) {
                this.visibleWeek = true;
            }
        },
        // 新增日期
        addDate(dateTime, index) {
            if (this.rowsDate.length === 10) {
                return;
            }
            if (!this.checkDateTime(false)) {
                return;
            }
            this.rowsDate.splice(index + 1, 0, dateTime);
        },
        // 删除日期
        deleteDate(index) {
            this.rowsDate.splice(index, 1);
        },
        // 新增星期
        addWeek(startWeek, startTime, endWeek, endTime, index) {
            if (this.rowsWeek.length === 10) {
                return;
            }
            if (!this.checkDateTime(false)) {
                return;
            }
            let item = {
                startWeek: startWeek,
                startTime: startTime,
                endWeek: endWeek,
                endTime: endTime
            };
            this.rowsWeek.splice(index + 1, 0, item);
        },
        // 删除星期
        deleteWeek(index) {
            this.rowsWeek.splice(index, 1);
        },
        // 获取数据
        getData() {
            let checkFlag = this.checkDateTime(true);
            if (!checkFlag) {
                return null;
            }
            let iTimeMode = this.formInfo.iTimeMode;
            let sDateTime = [];
            if (iTimeMode === window.pangu.common.timeMode.DATE_MODE) {
                for (let index = 0; index < this.rowsDate.length; index++) {
                    const element = this.rowsDate[index];
                    if (element.dateTime == null || element.dateTime.length == 0) {
                        continue;
                    }
                    let param = {
                        start: element.dateTime[0],
                        end: element.dateTime[1]
                    };
                    sDateTime.push(param);
                }
            } else if (iTimeMode === window.pangu.common.timeMode.WEEK_MODE) {
                for (let index = 0; index < this.rowsWeek.length; index++) {
                    const element = this.rowsWeek[index];
                    let param = {
                        start: {
                            week: element.startWeek,
                            time: element.startTime
                        },
                        end: {
                            week: element.endWeek,
                            time: element.endTime
                        }
                    };
                    sDateTime.push(param);
                }
            }
            let data = {};
            data.iTimeMode = iTimeMode;
            data.sDateTime = sDateTime;
            return data;
        },
        // 初始化数据数据
        initData(data) {
            let iTimeMode = data.iTimeMode;
            let sDateTime = data.sDateTime;
            this.formInfo.iTimeMode = '' + iTimeMode;
            this.changeTimeMode(this.formInfo.iTimeMode);
            if (sDateTime && sDateTime.length > 0) {
                for (let index = 0; index < sDateTime.length; index++) {
                    const element = sDateTime[index];
                    if (index === 0) {
                        if (this.formInfo.iTimeMode === window.pangu.common.timeMode.DATE_MODE) {
                            this.rowsDate[0].dateTime = [element.start, element.end];
                        } else if (this.formInfo.iTimeMode === window.pangu.common.timeMode.WEEK_MODE) {
                            this.rowsWeek = [];
                            this.rowsWeek.splice(0, 0, {
                                startWeek: element.start.week,
                                startTime: element.start.time,
                                endWeek: element.end.week,
                                endTime: element.end.time
                            });
                        }
                    } else {
                        if (this.formInfo.iTimeMode === window.pangu.common.timeMode.DATE_MODE) {
                            this.addDate({ dateTime: [element.start, element.end] }, index - 1);
                        } else if (this.formInfo.iTimeMode === window.pangu.common.timeMode.WEEK_MODE) {
                            this.addWeek(element.start.week, element.start.time, element.end.week, element.end.time, index - 1);
                        }
                    }
                }
            }
        },
        checkDateTime(flag) {
            let iTimeMode = this.formInfo.iTimeMode;
            if (iTimeMode === window.pangu.common.timeMode.DATE_MODE) {
                if (this.rowsDate.length == 0) {
                    this.$message({ showClose: true, message: this.$t('pgMessage.PLEASE_ADD_AT_LEAST_ONE_DATE_PERIOD'), type: 'warning' });
                    return false;
                }
                let start = [];
                let end = [];
                let empty = false;
                this.rowsDate.forEach(element => {
                    let dateTime = element.dateTime;
                    if (dateTime && dateTime.length > 0) {
                        start.push(dateTime[0]);
                        end.push(dateTime[1]);
                    } else {
                        empty = true;
                    }
                });
                start = start.sort();
                end = end.sort();
                if (flag && empty) {
                    this.$message({ showClose: true, message: this.$t('pgMessage.THERE_IS_AN_EMPTY_DATE_PERIOD'), type: 'warning' });
                    return false;
                }
                if (flag && (start.length == 0 || end.length == 0)) {
                    this.$message({ showClose: true, message: this.$t('pgMessage.PLEASE_ADD_AT_LEAST_ONE_DATE_PERIOD'), type: 'warning' });
                    return false;
                }
                for (let i = 1; i < start.length; i++) {
                    if (start[i] < end[i - 1]) {
                        this.$message({ showClose: true, message: this.$t('pgMessage.TIME_PERIODS_ARE_CROSSED'), type: 'warning' });
                        return false;
                    }
                }
            } else if (iTimeMode === window.pangu.common.timeMode.WEEK_MODE) {
                if (this.rowsWeek.length == 0) {
                    this.$message({ showClose: true, message: this.$t('pgMessage.PLEASE_ADD_AT_LEAST_ONE_WEEK_PERIOD'), type: 'warning' });
                    return false;
                }
                for (let j = 0; j < this.rowsWeek.length; j++) {
                    let weekObj = this.rowsWeek[j];
                    if (flag && ((!weekObj.startWeek && typeof weekObj.startWeek != 'number') || (!weekObj.endWeek && typeof weekObj.endWeek != 'number') || !weekObj.startTime || !weekObj.endTime)) {
                        this.$message({ showClose: true, message: this.$t('pgMessage.THERE_IS_AN_EMPTY_WEEK_PERIOD'), type: 'warning' });
                        return false;
                    }
                }
            }
            return true;
        },
        //星期校验
        changeWeek(item, field) {
            if (this.compareWeek(item)) {
                if (field == 'startWeek') {
                    item.endWeek = item.startWeek;
                } else if (field == 'endWeek') {
                    item.startWeek = item.endWeek;
                }
            }
            this.changeTime(item, field);
        },
        //时间校验
        changeTime(item, field) {
            if ((item.startWeek || item.startWeek === 0) && (item.endWeek || item.endWeek === 0)) {
                if (item.startWeek === item.endWeek && item.startTime && item.endTime && item.startTime > item.endTime) {
                    if (field == 'startTime' || field == 'startWeek') {
                        item.endTime = item.startTime;
                    } else if (field == 'endTime' || field == 'endWeek') {
                        item.startTime = item.endTime;
                    }
                }
            }
        },
        compareWeek(item) {
            if ((item.startWeek || item.startWeek === 0) && (item.endWeek || item.endWeek === 0)) {
                if ((item.startWeek > item.endWeek && item.endWeek !== 0) || item.startWeek === 0) {
                    return true;
                }
            }
            return false;
        }
    }
};
</script>
